import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Legend, Colors } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend);

const optionsChecksheet = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
        // title: {
        //     display: true,
        //     fontSize: 20,
        //     text: 'Checksheet'
        // }
    },
    cutout: '60%',
}

function ChecksheetChartWidget({ ChecksheetCharts }) {

    const totalTasks = (ChecksheetCharts?.todo || 0) +
        (ChecksheetCharts?.inprogress || 0) +
        (ChecksheetCharts?.complete || 0) +
        (ChecksheetCharts?.delay || 0) +
        (ChecksheetCharts?.completeDelay || 0);

    const hasData = totalTasks > 0;


    const data = {
        labels: ['Todo', 'In Progress', 'Completed', 'Delay', 'Delay Completed'],
        datasets: [
            {
                data: [ChecksheetCharts && ChecksheetCharts.todo, ChecksheetCharts && ChecksheetCharts.inprogress, ChecksheetCharts && ChecksheetCharts.complete, ChecksheetCharts && ChecksheetCharts.delay, ChecksheetCharts && ChecksheetCharts.completeDelay],
                backgroundColor: [
                    'rgb(146, 146, 146)',
                    'rgb(115, 97, 231)',
                    'rgb(100, 207, 92)',
                    'rgb(236, 219, 90)',
                    'rgb(232, 77, 77)',
                ], 
                borderWidth: 0,
            },
        ],
    };
    //dark theme image change 
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        // Check for the theme on initial load
        const currentTheme = document.body.classList.contains("dark-theme");
        setIsDarkTheme(currentTheme);

        // Listen for changes to the body's class (if toggling happens outside this component)
        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains("dark-theme");
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme image change end
    return (
        <>
            <div className='card text-center graph-card h-100 mb-0'>
                <div className='card-body'>
                    <h5 className='card-title mb-2'>Repeat Task</h5>
                    {hasData ?
                        <div className='chart-wrap'>
                            <Doughnut options={optionsChecksheet} data={data} />
                            <p>Select / Deselect legends</p>
                        </div> :
                        <div className='chart-wrap-nodata'>
                            <img
                                src={
                                    isDarkTheme
                                        ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
                                        : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
                                }
                                className="img-fluid"
                                alt="no-data"
                            />
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default ChecksheetChartWidget